// extracted by mini-css-extract-plugin
module.exports = {"nav":"index-module--nav--7J8w_"};